import echarts from './echartsCore';
import { chartThemeTokens, ThemeTokens } from '../../../helpers/chartTheme';
import { ResolvedTheme } from '../../../context/ThemeContext';

const FONT_FAMILY = 'system-ui, Arial, sans-serif';

const SERIES_PALETTE = [
    '#2caffe', '#544fc5', '#00e272', '#fe6a35', '#6b8abc',
    '#d568fb', '#2ee0ca', '#fa4b42', '#feb56a', '#91e8e1',
];

function makeEchartsTheme(t: ThemeTokens) {
    const axis = {
        axisLine: { lineStyle: { color: t.axisLine } },
        axisTick: { lineStyle: { color: t.axisLine } },
        axisLabel: { color: t.subtleText, fontFamily: FONT_FAMILY },
        splitLine: { lineStyle: { color: t.gridLine } },
    };
    return {
        color: SERIES_PALETTE,
        backgroundColor: 'transparent',
        textStyle: { color: t.text, fontFamily: FONT_FAMILY },
        title: { textStyle: { color: t.text }, subtextStyle: { color: t.subtleText } },
        timeAxis: axis,
        valueAxis: axis,
        categoryAxis: axis,
        bar: {
            itemStyle: { borderColor: t.seriesBorder, borderWidth: 1 },
            label: { color: t.text },
        },
        pie: {
            itemStyle: { borderColor: t.seriesBorder, borderWidth: 1 },
            label: {
                color: t.text,
                textBorderColor: t.pieLabelOutline === 'none' ? 'transparent' : t.seriesBorder,
                textBorderWidth: t.pieLabelOutline === 'none' ? 0 : 2,
            },
        },
        legend: {
            textStyle: { color: t.text, fontFamily: FONT_FAMILY },
            inactiveColor: t.legendHidden,
            pageTextStyle: { color: t.text },
            pageIconColor: t.legendActive,
            pageIconInactiveColor: t.legendInactive,
        },
    };
}

const themeNames: Record<ResolvedTheme, string> = {
    light: 'dbm-light',
    dark: 'dbm-dark',
    midnight: 'dbm-midnight',
};

(Object.keys(themeNames) as ResolvedTheme[]).forEach(theme => {
    echarts.registerTheme(themeNames[theme], makeEchartsTheme(chartThemeTokens[theme]));
});

export function getEchartsThemeName(theme: ResolvedTheme): string {
    return themeNames[theme];
}
